import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';
import clsx from 'clsx';

export const Route = createFileRoute('/admin/dictionary')({
  component: DictionaryLayout,
});

const SUBTABS = [
  { to: '/admin/dictionary', label: 'Review', exact: true },
  { to: '/admin/dictionary/list', label: 'Browse', exact: false },
] as const;

function DictionaryLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Dictionary</h1>
        <p className="mt-1 text-sm text-gray-600">
          Review pending extracted terms or browse entries by review status.
        </p>
      </div>

      <nav className="flex gap-1 rounded-2xl border border-gray-100 bg-gray-50/80 p-1">
        {SUBTABS.map((tab) => {
          const active = tab.exact
            ? pathname === tab.to || pathname === `${tab.to}/`
            : pathname.startsWith(tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={clsx(
                'rounded-xl px-4 py-2 text-sm font-medium transition-colors',
                active
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-500 hover:text-gray-800'
              )}
            >
              {tab.label}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </div>
  );
}
